<template>
  <header>
    <div class="bg-[#EF0505] text-white py-2 px-6 relative">
      <ul class="md:hidden absolute right-2 top-1">
        <li>
          <i
            @click="toggle"
            class="fa-solid text-3xl fa-bars cursor-pointer"
          ></i>
        </li>
      </ul>
      <div class="max-w-5xl mx-auto flex justify-between items-center">
        <router-link to="/"
          ><img src="@/assets/images/icone.png" class="w-8"
        /></router-link>
        <ul class="hidden md:flex justify-center items-center gap-16">
          <li>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e2e9cf8bf754eed63dad/politique.pdf"
              target="_blank"
              >Politique de confidentialité</a
            >
          </li>
          <li>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e2e9cf8bf754eed63dad/reglement.pdf"
              target="_blank"
              >Règlement</a
            >
          </li>
          <li>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e2e9cf8bf754eed63dad/modalites.pdf"
              target="_blank"
              >Mentions légales</a
            >
          </li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </div>
    </div>
    <Teleport to="body">
      <Drawer @close="toggle" align="right" :closeable="true">
        <div v-if="open">
          <ul class="text-2xl text-[#6F1710] space-x-6">
            <li @click="toggle">
              <a
                class="uppercase"
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e1b0cf8bf754eed61ce3/politique.pdf"
                target="_blank"
                >Politique de confidentialité</a
              >
            </li>
            <li @click="toggle">
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e1b0cf8bf754eed61ce3/reglement.pdf"
                target="_blank"
                >RÈGLEMENT</a
              >
            </li>
            <li @click="toggle">
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/6798e2e9cf8bf754eed63dad/modalites.pdf"
                target="_blank"
                >MENTIONS LÉGALES</a
              >
            </li>
            <li @click="toggle">
              <router-link to="/contact">CONTACT</router-link>
            </li>
          </ul>
        </div>
      </Drawer>
    </Teleport>
  </header>
</template>

<script>
import Drawer from "vue-simple-drawer";
import Teleport from "vue2-teleport";
export default {
  name: "header-view",
  components: {
    Drawer,
    Teleport,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
